export type ActionFunction<T1, R> = (t1?: T1) => R;

export interface Action<Payload> {
	type: string;
	payload?: Payload;
	error?: boolean;
}

export interface IApiAction<Payload, SuccessData, ErrorMessage> {
	default: ActionFunction<Payload, Action<Payload>>;
	loading: ActionFunction<Payload, Action<Payload>>;
	success: ActionFunction<SuccessData, Action<SuccessData>>;
	fail: ActionFunction<ErrorMessage, Action<ErrorMessage>>;
}

interface IApiActionTypes {
	DEFAULT: string;
	REQUEST: string;
	SUCCESS: string;
	FAILURE: string;
}

export const createAction = (type: string) =>
	function action<Payload, R>(payload?: Payload, ...rest: any[]) {
		return {
			type,
			payload,
			...rest,
		};
	};

export const createApiAction = <
	Payload = {},
	SuccessData = {},
	ErrorMessage = string
>(
	type: IApiActionTypes,
): IApiAction<Payload, SuccessData, ErrorMessage> => ({
	default: createAction(type.DEFAULT),
	fail: createAction(type.FAILURE),
	loading: createAction(type.REQUEST),
	success: createAction(type.SUCCESS),
});

export const createApiActionTypes = (base: string): IApiActionTypes => ({
	DEFAULT: base,
	FAILURE: `${base}_FAILURE`,
	REQUEST: `${base}_REQUEST`,
	SUCCESS: `${base}_SUCCESS`,
});

export const requestActionHandler = (state: any) => ({
	...state,
	isLoading: true,
});

export const failureActionHandler = (
	state: any,
	{ payload }: { payload: Error },
	...rest: Record<string, unknown>[]
) => ({
	...state,
	error: payload,
	isLoading: false,
	...rest,
});

export function successActionHandler<T>(state: T): T {
	return {
		...state,
		error: undefined,
		isLoading: false,
	};
}
